import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import setup from './config/setup';
import { AppProvider } from 'context/AppContext';
import { AuthProvider } from 'context/AuthContext';
import { AuthGuardProvider } from 'context/AuthGuardContext';
import { GoogleAnalyticsProvider } from './utils/googleAnalytics';
import { PageScroll } from './components';
import { unregister } from './registerServiceWorker';
import { SegmentProvider } from 'context/SegmentContext';
import { LogRocketProvider } from 'context/LogRocketProvider';
// import registerServiceWorker from './registerServiceWorker';

// disable ServiceWorker

setup();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProvider>
        <GoogleAnalyticsProvider>
          <AuthGuardProvider>
            <AuthProvider>
              <LogRocketProvider>
                <SegmentProvider>
                  <PageScroll.Provider>
                    <App />
                  </PageScroll.Provider>
                </SegmentProvider>
              </LogRocketProvider>
            </AuthProvider>
          </AuthGuardProvider>
        </GoogleAnalyticsProvider>
      </AppProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

unregister();
// disable ServiceWorker
// registerServiceWorker();
